<template>
  <div :class="{
    '_disabled': disabled,
    '_request-sent': requestSentC
  }"
       class="payment-account-open-card">
    <picture v-if="disabled"
             class="payment-account-open-card__logo">
      <img src="@/assets/img/payment/satchelpay-gray.svg"
           alt="Akord">
    </picture>
    <picture v-else
             class="payment-account-open-card__logo">
      <img src="@/assets/img/payment/satchelpay.svg"
           alt="Akord">
    </picture>
    <!--<div class="payment-account-open-card__info">
      <BaseSvg name="ico-info"/>
    </div>-->
    <template v-if="!show_form">
      <template v-if="requestSentC">
        <div class="payment-account-open-card__text  text  _request-sent">
          <p>{{
              $tPayment('video-start')
            }} <strong>Jobian Pay</strong>.</p>
          <p>{{
              $tPayment('video-pass')
            }}</p>
        </div>

        <div class="payment-account-open-card__app-links">
          <a href="#"
             class="payment-account-open-card__app-link">
            <img src="@/assets/img/google-play-logo.svg"
                 alt="google-play">
          </a>
          <a href="#"
             class="payment-account-open-card__app-link">
            <img src="@/assets/img/apple-store-logo.svg"
                 alt="apple-store">
          </a>
        </div>
        <!--
        <button class="payment-account-open-card__cancel-request">
          <BaseSvg name="ico-trash"
                   width="1.4rem"
                   height="1.6rem"/>
          <span>Скасувати заявку</span>
        </button>-->
      </template>

      <div v-else-if="disabled"
           class="payment-account-open-card__text  text">
        <p>{{ $tPayment('acord-start') }}</p>
      </div>

      <template v-else>
        <div
          class="payment-account-open-card__text  text">
          <p>{{ $tPayment('anketa-start') }}:</p>
        </div>

        <div class="payment-account-open-card__soc-items">
          <template v-for="messenger in messengers">
            <a v-if="urlsComputed[messenger]"
               :key="messenger"
               :href="urlsComputed[messenger]"
               target="_blank"
               @click="onRespond(messenger)"
               :class="'_' + messenger"
               class="payment-account-open-card__soc-item">
              <BaseSvg :name="`ico-${messenger}`"/>
            </a>
            <div v-else
                 :key="messenger"
                 :class="'_' + messenger"
                 class="payment-account-open-card__soc-item  _disabled">
              <BaseSvg :name="`ico-${messenger}`"/>
            </div>
          </template>
          <!--<a href="viber://pa?chatURI=jobiantestbot&context=jobianpay" target="_blank" class="payment-account-open-card__soc-item  _viber  ">
            <BaseSvg name="ico-viber"/>
          </a>
          <div href="#" class="payment-account-open-card__soc-item  _disabled _telegram  ">
            <BaseSvg name="ico-telegram"/>
          </div>
          <div href="#" class="payment-account-open-card__soc-item  _disabled _messenger  ">
            <BaseSvg name="ico-messenger"/>
          </div>-->
        </div>
        <!--
        <div class="payment-account-open-card__btns">
          <button class="payment-account-open-card__btn  _has-account  inline-link">
            {{ $tPayment('В мене вже є рахунок') }}
          </button>
        </div>
        -->

        <div class="payment-account-open-card__btns">
          <button @click="showForm()" class="payment-account-open-card__btn  _has-account  inline-link">
            {{ $tPayment('continue on site') }}
          </button>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="register-candidate-form">
        <div class="register-candidate-form__header-block">
          <h1 class="register-candidate-form__header">
            <span>{{ $tPayment('Register') }}</span>
            <BaseSvg name="ico-check-rectangular" width="2.8rem" height="2.1rem" />
          </h1>
          <div class="register-candidate-form__header-block-subheader"></div>
        </div>

        <RegisterCandidateFormBlock :header="$tPayment('Personal data')">
          <div class="register-candidate-form__row-inputs">
            <BaseInput v-model="formData.applicantFirstName" :label="$tPayment('Name')" ref="applicantFirstName" :error="validationErrors.applicantFirstName" />
            <BaseInput v-model="formData.applicantLastName" :label="$tPayment('Surname')" ref="applicantLastName" :error="validationErrors.applicantLastName" />
            <BaseInput v-model="formData.applicantEmail" :label="$tPayment('Email')" ref="applicantEmail" :error="validationErrors.applicantEmail" />
          </div>
        </RegisterCandidateFormBlock>

        <RegisterCandidateFormBlock :header="$tPayment('Date of Birth')">
          <div class="register-candidate-form__row-inputs">
            <BirthdaySelect v-model="formData.applicantBirthDate" ref="applicantBirthDate" :error="validationErrors.applicantBirthDate" />
          </div>
        </RegisterCandidateFormBlock>

        <RegisterCandidateFormBlock :header="$tPayment('Country of birth')">
          <div class="register-candidate-form__row-inputs">
            <BaseSelect v-bind="$attrs"
                        v-model="formData.applicantBirthCountryId"
                        :options="formData.applicantBirthCountryId_list"
                        ref="applicantBirthCountryId" :error="validationErrors.applicantBirthCountryId"
                        @input="onInputApplicantBirthCountryId"
                        textKey="name"/>
          </div>
        </RegisterCandidateFormBlock>

        <RegisterCandidateFormBlock :header="$tPayment('Nationality country')">
          <div class="register-candidate-form__row-inputs">
            <BaseSelect v-bind="$attrs"
                        v-model="formData.applicantNationality"
                        :options="formData.nationality_list"
                        :error="validationErrors.applicantNationality"
                        ref="applicantNationality"
                        @input="onInputApplicantNationality"
                        textKey="name"/>
          </div>
        </RegisterCandidateFormBlock>

        <RegisterCandidateFormBlock :header="$tPayment('Passport')">
          <div class="register-candidate-form__row-inputs">
            <BaseInput v-model="formData.applicantPassportId" :label="$tPayment('Passport series number')" ref="applicantPassportId" :error="validationErrors.applicantPassportId" />
          </div>
          <div class="register-candidate-form__row-inputs">
            <label class="select  _over  _filled " :class="{_error: validationErrors.applicantDateExpire}"><div class="input__label"><span>{{ $tPayment('Date of passport expire')}}</span></div>
            <BirthdaySelect v-model="formData.applicantDateExpire" :maxYear="maxYear" ref="applicantDateExpire" :error="validationErrors.applicantDateExpire" />
            </label>
          </div>
          <div class="register-candidate-form__certificates-and-diplomas">
            <label class="input  _over  _filled "><div class="input__label"><span>{{ $tPayment('Passport attachments')}}</span></div></label>
            <BaseRadioList
              v-model="formData.documents.showed"
              text-key="name"
              class="mb-6"
            />

            <div
              v-for="(file, index) in formData.documents.files"
              :key="index"
              class="d-flex register-candidate-form__inset-block" :class="{_error: formData.documents.files.error}">
              <button
                v-if="formData.documents.files.length > 1"
                class="base-btn register-candidate-form__remove-block-button"
                @click="deleteFormDocument(index)"
              >
                <BaseSvg name="ico-cross" width="1.2rem" height="1.2rem" />
              </button>

              <div>
                <div class="register-candidate-form__document-upload-title">{{ $tPayment('Upload') }}</div>
                <FilesUpload
                  v-model="file.value"
                  :max="1"
                />
              </div>
            </div>

            <div>
              <button
                class="base-btn base-btn--small register-candidate-form__add-button"
                @click="addFormDocument"
              >
                <BaseSvg name="ico-plus" width="1.2rem" height="1.2rem" />
                <span>{{ $tPayment('Add document') }}</span>
              </button>
            </div>
          </div>
        </RegisterCandidateFormBlock>

        <RegisterCandidateFormBlock :header="$tPayment('Country of jurisdiction')">
          <div class="register-candidate-form__row-inputs">
            <BaseSelect v-bind="$attrs"
                        v-model="formData.jurisdiction"
                        :options="formData.jurisdiction_list"
                        ref="jurisdiction" :error="validationErrors.jurisdiction"
                        @input="onInputJurisdiction"
                        textKey="name"/>
          </div>
        </RegisterCandidateFormBlock>

        <RegisterCandidateFormBlock :header="$tPayment('Taxes')">
          <div class="register-candidate-form__row-inputs">
            <BaseSelect v-bind="$attrs" :label="$tPayment('Tax country')"
                        v-model="formData.taxCountry"
                        :options="formData.tax_country_list"
                        ref="taxCountry" :error="validationErrors.taxCountry"
                        @input="onInputTaxCountry"
                        textKey="name"/>
          </div>
          <div class="register-candidate-form__row-inputs">
            <BaseInput v-model="formData.taxIdentificationNumber" :label="$tPayment('Tax identification number')" ref="taxIdentificationNumber" :error="validationErrors.taxIdentificationNumber" />
          </div>
        </RegisterCandidateFormBlock>

        <RegisterCandidateFormBlock :header="$tPayment('PEP')">
          <div class="register-candidate-form__row-inputs">
            <BaseCheckbox
                          v-model="formData.positionInAnyCountry"
                          key="positionInAnyCountry"
                          :label="$tPayment('Position In Any Country')"
                          :checked="formData.positionInAnyCountry"
                          class="main-filter__checkbox"/>
          </div>
          <div class="register-candidate-form__row-inputs">
            <BaseCheckbox
                          v-model="formData.familyPositionInAnyCountry"
                          key="familyPositionInAnyCountry"
                          :label="$tPayment('Family Position In Any Country')"
                          :checked="formData.familyPositionInAnyCountry"

                          class="main-filter__checkbox"/>
          </div>
        </RegisterCandidateFormBlock>

        <RegisterCandidateFormBlock>
          <div class="register-candidate-form__register-btn-wrap">
            <button
                    class="register-candidate-form__register-btn base-btn base-btn--green"
                    @click="register"
            >
              {{$tPayment('Register')}}
            </button>
          </div>
          <BaseAlert v-if="show.registerError" :value="registerError" class="mt-4 _error" />
        </RegisterCandidateFormBlock>
      </div>
    </template>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import { mapGetters } from 'vuex';
  import RegisterCandidateFormBlock from '@/components/register-candidate/RegisterCandidateFormBlock';
  import BirthdaySelect from '@/components/BirthdaySelect';
  import FilesUpload from '@/components/FilesUploadMultiple';
  import { serialize } from 'object-to-formdata';

  function formDefaultFile() {
    return {
      type: '',
      name: '',
      value: [],
      error: false
    };
  }
  export default {
    name: 'PaymentAccountOpenCardSatchelPay',
    props: {
      disabled: Boolean,
      requestSent: Boolean,
      maxYear: {
        type: [String, Number],
        default: new Date().getFullYear() + 10,
      },
    },
    components: {
      RegisterCandidateFormBlock,
      BirthdaySelect,
      FilesUpload,
    },
    data() {
      return {
        registerError: this.$tPayment('All fields are required'),
        validationErrors: {
          'lastName':0,
        },
        approved: false,
        messengers: [
          'viber',
          'telegram',
          'messenger',
        ],
        show_form: 0,
        show: {
          errorMessage: this.$tPayment('All fields are required'),
          registerError: false,
          additionalQuestions: false,
        },

        formData: {
          applicantFirstName: '',
          applicantLastName: '',
          applicantBirthDate: new Date,
          applicantNationality: {'id': 0, 'name':this.$tPayment('Other')},
          nationality_list: [
              {'id': 0, 'name':this.$tPayment('Other')},
              {'id': 216, 'name':this.$tPayment('Ukraine')},
          ],
          applicantPassportId: '',
          passportAttachmentItems: '',
          applicantDateExpire: '',
          applicantEmail: '',
          jurisdiction: '',
          jurisdiction_list: [
              {'id': 0, 'name':this.$tPayment('Other')},
              {'id': 165, 'name':this.$tPayment('Poland')},
              {'id': 110, 'name':this.$tPayment('Lithuania')},
          ],
          taxCountry: {'id': 0, 'name':this.$tPayment('Other')},
          tax_country_list: [
              {'id': 0, 'name':this.$tPayment('Other')},
              {'id': 216, 'name':this.$tPayment('Ukraine')},
          ],
          taxIdentificationNumber: '',
          documents: {
            showed: null,
            files: [
              formDefaultFile(),
            ],
          },
          applicantBirthCountryId: '',
          applicantBirthCountryId_list: [
            {'id': 0, 'name':this.$tPayment('Other')},
            {'id': 216, 'name':this.$tPayment('Ukraine')},
            {'id': 170, 'name':this.$tPayment('Russia')},
            {'id': 20, 'name':this.$tPayment('Belarus')},
          ],
          positionInAnyCountry: 0,
          familyPositionInAnyCountry: 0
        },
      }
    },
    computed: {
      requestSentC() {
        return this.requestSent || this.approved
      },
      urlsComputed() {
        return this.$store.state.user.chatBotUrlsJobianPay
      },
      ...mapGetters({
        dataLists: 'candidate/register/formLists',
      }),
    },
    methods: {
      onInputTaxCountry(value) {
        console.log(value);
        if(value.id===0)
        this.$vModal.open('payment-account-country-deny', {
          text: '<p>'+this.$tPayment('TaxCountryPopUp')+'</p>'
        })
      },
      onInputJurisdiction(value) {
        if(value.id===0)
          this.$vModal.open('payment-account-country-deny', {
            text: '<p>'+this.$tPayment('JurisdictionPopUp')+'</p>'
          })
      },
      onInputApplicantNationality(value) {
        if(value.id===0)
          this.$vModal.open('payment-account-country-deny', {
            text: '<p>'+this.$tPayment('NationalityPopUp')+'</p>'
          })
      },
      onInputApplicantBirthCountryId(value) {
        if(value.id===0)
          this.$vModal.open('payment-account-country-deny', {
            text: '<p>'+this.$tPayment('BirthCountryPopUp')+'</p>'
          })
      },
      onRespond(messenger) {
        console.log('respond '+messenger);
      },
      showForm() {
        //console.log('form ');
        http.get('/api/jobian-pay/get-jobian-pay-form')
            .then(({data}) => {
              this.formData.applicantFirstName = data.satchel_form.applicantFirstName;
              this.formData.applicantLastName = data.satchel_form.applicantLastName;
              this.formData.applicantBirthDate = data.satchel_form.applicantBirthDate;
              this.formData.applicantEmail = data.satchel_form.applicantEmail;
              this.formData.applicantNationality = data.satchel_form.applicantNationality?{'id': 216, 'name':this.$tPayment('Ukraine')}:'';
              this.formData.jurisdiction = '';
              if(data.satchel_form.jurisdiction===165){
                this.formData.jurisdiction = {'id': 165, 'name':this.$tPayment('Poland')};
              }
              if(data.satchel_form.jurisdiction===110){
                this.formData.jurisdiction = {'id': 110, 'name':this.$tPayment('Lithuania')};
              }
              this.formData.applicantBirthCountryId = '';
              if(data.satchel_form.applicantBirthCountryId===216){
                this.formData.applicantBirthCountryId = {'id': 216, 'name':this.$tPayment('Ukraine')};
              }
              if(data.satchel_form.applicantBirthCountryId===170){
                this.formData.applicantBirthCountryId = {'id': 170, 'name':this.$tPayment('Russia')};
              }
              if(data.satchel_form.applicantBirthCountryId===20){
                this.formData.applicantBirthCountryId = {'id': 20, 'name':this.$tPayment('Belarus')};
              }
              this.formData.taxCountry = data.satchel_form.taxCountry?{'id': 216, 'name':this.$tPayment('Ukraine')}:'';
              this.formData.applicantPassportId = data.satchel_form.applicantPassportId;
              this.formData.applicantDateExpire = data.satchel_form.applicantDateExpire;
              this.formData.taxIdentificationNumber = data.satchel_form.taxIdentificationNumber;
              this.formData.positionInAnyCountry = data.satchel_form.positionInAnyCountry;
              this.formData.familyPositionInAnyCountry = data.satchel_form.familyPositionInAnyCountry;
              //this.formData.passportAttachmentItems = data.satchel_form.passportAttachmentItems;
              if(data.satchel_form.passportAttachmentItems) {
                this.formData.documents.files = [];
                data.satchel_form.passportAttachmentItems.forEach(function callback(currentValue) {
                   let item = {
                        value: [{
                          path: currentValue,
                          type:"image/png",
                          file: File
                        }]
                      };
                  this.formData.documents.files.push(item);
                },this);
              }
            });
        this.show_form = 1;
      },
      onInput(value) {
        this.$emit('input', value)
      },
      addFormDocument() {
        this.formData.documents.files.push(formDefaultFile());
      },
      deleteFormDocument(idx) {
        this.formData.documents.files.splice(idx, 1);
      },
      async register() {
        // console.log('register ');
        this.show.registerError = false;
        //console.log(serialize(this.formData));
        http.post('/api/jobian-pay/save-jobian-pay-form', serialize(this.formData)).then(({data}) => {
          //console.log(data);
          if(data.status===0) {
            //this.show.registerError = true;
            if(!data.errors){
              this.registerError = this.$tPayment('error_Registered');
              this.show.registerError = true;
            }else
              this.showValidationErrors(data.errors)
          }else{
            this.validationErrors = {};
            this.show.registerError = false;
            this.$emit('refresh-status',data)
            this.show_form = 0;
          }
        });
      },
      showValidationErrors(errors) {
        this.validationErrors = {};
        this.formData.documents.files.error = false
        let messages = [];
       // let msg = '';
        errors.forEach(function (error) {
          switch (error) {
            case 'applicantFirstName':
              this.validationErrors.applicantFirstName = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_applicantFirstName'));
              break;
            case 'applicantLastName':
              this.validationErrors.applicantLastName = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_applicantLastName'));
              break;
            case 'applicantBirthDate':
              this.validationErrors.applicantBirthDate = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_applicantBirthDate'));
              break;
            case 'applicantNationality':
              this.validationErrors.applicantNationality = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_applicantNationality'));
              break;
            case 'applicantBirthCountryId':
              this.validationErrors.applicantNationality = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_applicantBirthCountryId'));
              break;
            case 'positionInAnyCountry':
              this.validationErrors.applicantNationality = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_positionInAnyCountry'));
              break;
            case 'familyPositionInAnyCountry':
              this.validationErrors.applicantNationality = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_familyPositionInAnyCountry'));
              break;
            case 'applicantPassportId':
              this.validationErrors.applicantPassportId = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_applicantPassportId'));
              break;
            case 'documents':
            case 'passportAttachmentItems':
              //this.validationErrors.passportAttachmentItems = this.$tPayment('error_required');
              this.formData.documents.files.error = true
              messages.push(this.$tPayment('error_passportAttachmentItems'));
              break;
            case 'applicantDateExpire':
              this.validationErrors.applicantDateExpire = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_applicantDateExpire'));
              break;
            case 'applicantEmail':
              this.validationErrors.applicantEmail = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_applicantEmail'));
              break;
            case 'jurisdiction':
              this.validationErrors.jurisdiction = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_jurisdiction'));
              break;
            case 'taxCountry':
              this.validationErrors.taxCountry = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_taxCountry'));
              break;
            case 'taxIdentificationNumber':
              this.validationErrors.taxIdentificationNumber = this.$tPayment('error_required');
              messages.push(this.$tPayment('error_taxIdentificationNumber'));
              break;
          }
        },this);
        if(messages)
        this.registerError = messages;
        this.show.registerError = true;

        /*if (response.errors && !isEmpty(response.errors)) {
          const { errors } = response.errors;
          this.validationErrors = errors;
          const refsEntries = Object.entries(this.$refs);

          for (const [key, ref] of refsEntries) {
            if (!errors[key]) continue;

            ref.$el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            break;
          }
        }*/
      },
    }
  }
</script>

<style lang="less">

</style>
